import { gql } from "@apollo/client"

const GET_NOTIFICATION_META_DATA = gql`
  query {
    notificationRecipientTypes {
      id
      name
      code
    }

    notificationStatus {
      id
      name
      code
    }

    notificationTypes {
      id
      is_app
      is_email
      show
      name
      code
    }

    sesEmailStatuses {
      id
      name
      code
      description
      is_queued
      is_delivered
      is_failed
      is_unknown
    }
  }
`

export { GET_NOTIFICATION_META_DATA }